import Backbone from 'backbone';

import { PLAN_TYPE_PREMIUM } from 'const_shared/zf_plan_types.js';
import { getDefaultErrorStringForXhr } from 'zoomforth_tools/error_messaging.js';

var Account = Backbone.Model.extend({
  /*
    see account.py for a full list of properties
  */
  
  initialize: function() {
    this.listenTo(this, 'error', function(model, xhr){
      alert('Your change was not saved. ' + getDefaultErrorStringForXhr(xhr));
    });
  },

  urlRoot: '/api/accounts',

  isPremiumAccount: function() {
    return this.get('zf_plan_type') === PLAN_TYPE_PREMIUM;
  },
  
  hasDomainForRoutes: function() {
    return !!this.get('default_domain_id');
  },
  
  getDefaultDomainUrl: function() {
    return this.get('default_domain_url');
  },

  hasCustomerManagedEncryptionKeyEnabled() {
    return this.get('is_kms_aware');
  },

  isSitePreviewCollaborationEnabled() {
    return this.get('is_enabled_site_preview_collaboration') || false;
  }
  
});

export default Account;
